import { SvgIcon } from "@mui/material";
import { useCallback } from "react";
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';

const useUploadFileBtn = () => {

    const uploadFile = useCallback(() => {

    }, [])

    const uploadFileBtn = {
        id: 2,
        icon: <SvgIcon component={AddIcon} inheritViewBox />,
        label: "העלאת קובץ",
        action: uploadFile,
        height: "35px",

        feature: "write__test_taker",
        permissionHOC: "hidden",
        role: "create"
    }

    return uploadFileBtn
}

export default useUploadFileBtn;